import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ProjectPrecinctGetCollectionByProjectId, ProjectPrecinctGetCollectionByProjectIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ProjectPrecinctGetCollectionByProjectIdResponse, ProjectPrecinctGetCollectionByProjectIdResponse>) => {
    return response?.data?.projectPrecincts;
}
const getError = (response?: SWRResponse<ProjectPrecinctGetCollectionByProjectIdResponse, ProjectPrecinctGetCollectionByProjectIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useProjectPrecinctsByProjectId = (projectId: number, configuration?: SWRConfiguration<ProjectPrecinctGetCollectionByProjectIdResponse, ProjectPrecinctGetCollectionByProjectIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ProjectPrecinctGetCollectionByProjectId({
                projectId: projectId
            });
        };
    }, [projectId])

    return useGet(request, { getData, getError }, configuration);
}

export default useProjectPrecinctsByProjectId;